// ##############################
// // // RegularForms view styles
// #############################

import {
  cardTitle,
  successColor,
  dangerColor
} from "assets/jss/material-dashboard-pro-react.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const regularFormsStyle = {
  ...customCheckboxRadioSwitch,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  staticFormGroup: {
    marginLeft: "0",
    marginRight: "0",
    paddingBottom: "10px",
    margin: "8px 0 0 0",
    position: "relative",
    "&:before,&:after": {
      display: "table",
      content: '" "'
    },
    "&:after": {
      clear: "both"
    }
  },
  staticFormControl: {
    marginBottom: "0",
    paddingTop: "8px",
    paddingBottom: "8px",
    minHeight: "34px"
  },
  inputAdornment: {
    marginRight: "8px",
    position: "relative"
  },
  inputAdornmentIconSuccess: {
    color: successColor + "!important"
  },
  inputAdornmentIconError: {
    color: dangerColor + "!important"
  },
  sliderClass: {
    position: "relative",
    background: "#F00",
    border: "solid thick",
    margin: "50px"
  },
  horizontalSlider: {
    width: "100%",
    maxWidth: "500px",
    height: "50px",
    border: "1px solid grey",
    exampleTrack: {
      top: "20px",
      height: "10px",
    },
    exampleThumb: {
      top: "1px",
      width: "50px",
      height: "48px",
      lineHeight: "38px",
    }
  },

  verticalSlider: {
    height: "380px",
    width: "50px",
    border: "1px solid grey",
    exampleThumb: {
      left: "1px",
      width: "48px",
      lineHeight: "40px",
      height: "50px",
    },
    exampleTrack: {
      left: "20px",
      width: "10px",
    }
  },

  exampleThumb: {
    fontSize: "0.9em",
    textAlign: "center",
    backgroundColor: "black",
    color: "white",
    cursor: "pointer",
    border: "5px solid gray",
    boxSizing: "border-box",
    active: {
      backgroundColor: "grey",
    }
  },

  exampleTrack: {
    position: "relative",
    background: "#ddd",
    exampleTrack1: {
      background: "#f00",
    },
    exampleTrack2: {
      background: "#0f0",
    }
  },


};

export default regularFormsStyle;
